import type { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';

/**
 * Toggle-style amount button overrides for use with `intent="neutral" variant="outline"`.
 * Pins border color across hover/active states and dims it when unselected.
 *
 * Long-term: if ButtonV2 gains `[aria-pressed="true"]` styling, this can be
 * replaced with just `borderRadius={3}` on the JSX element.
 */
export const getAmountButtonOverrides = (isSelected: boolean): ButtonOverrides => {
  const borderColor = isSelected ? 'mono14' : 'mono5';
  return {
    Root: {
      props: {
        borderRadius: 3,
        borderColor,
        color: 'inherit',
        _hover: {
          borderColor,
        },
        _active: {
          borderColor,
        },
      },
    },
  };
};
